export enum TemplatesNamesEnum {
  ENROLL_TEMPLATE = 'enroll-template',
}

export enum MailTemplateVariableTypesEnum {
  HTML = 'HTML',
}
